import { render, staticRenderFns } from "./CellRendererActions.vue?vue&type=template&id=488e6055&scoped=true"
import script from "./CellRendererActions.vue?vue&type=script&lang=js"
export * from "./CellRendererActions.vue?vue&type=script&lang=js"
import style0 from "./CellRendererActions.vue?vue&type=style&index=0&id=488e6055&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488e6055",
  null
  
)

export default component.exports